{
  "logoPosition": "right",
  "pages": [
    {
      "name": "page1",
      "elements": [
        {
          "type": "text",
          "name": "name",
          "title": "Navn",
          "description": "Kort intern beskrivelse af version",
          "isRequired": true
        },
        {
          "type": "text",
          "name": "required_maintenance_minutes",
          "title": "Påkrævede Vedligeholdelsesminutter",
          "description": "0 for deaktivering! Minutter der skal indhentes via moduler på events, for at vedligeholde en uddannelsesvej",
          "isRequired": true,
          "inputType": "number"
        },
        {
          "type": "boolean",
          "name": "recurrence_type",
          "title": "Vedligeholdelsestype",
          "description": "Skal vedligeholdelsen følge kalenderår med gentagelsen herunder, eller brugerens dato for fuldendt uddannelsesvej?",
          "labelTrue": "Følg bruger",
          "labelFalse": "Følg kalender",
          "defaultValue": false
        },
        {
          "type": "text",
          "name": "recurrence_value",
          "title": "Gentagelse af vedligeholdelsesminutter",
          "description": "Hvor ofte skal denne gentages (enhed, fx dage, måneder eller år, vælges herefter)",
          "requiredIf": "{recurrence_unit} notempty",
          "inputType": "number"
        },
        {
          "type": "dropdown",
          "name": "recurrence_unit",
          "title": "Gentagelse Enhed",
          "requiredIf": "{recurrence_value} notempty",
          "choices": [
            {
              "value": "full_period",
              "text": "Fulde periode for version (Ignorer gentagelse)"
            },
            {
              "value": "day",
              "text": "Dage"
            },
            {
              "value": "month",
              "text": "Måneder"
            },
            {
              "value": "year",
              "text": "År"
            }
          ]
        },
        {
          "type": "text",
          "name": "recurrence_calendar_anchor_date",
          "title": "Kalender startdato",
          "description": "Hvornår starter vedligeholdelsesperioden? Ved år tæller kun årstallet; ved måneder og dage tæller den fulde dato. Ikke nødvendig ved 1-års kalender (1. jan–31. dec).",
          "inputType": "date",
          "visibleIf": "({recurrence_type} empty or {recurrence_type} = false) and {recurrence_unit} notempty and {recurrence_unit} <> 'full_period' and ({recurrence_unit} <> 'year' or ({recurrence_value} <> 1 and {recurrence_value} <> '1'))"
        },
        {
          "type": "boolean",
          "name": "reset_on_fulfillment",
          "title": "Vedligeholdelsesperiode",
          "description": "Skal perioden starte forfra når vedligeholdelse er opfyldt?",
          "visibleIf": "{recurrence_type} = true",
          "defaultValue": false,
          "labelFalse": "Almindeligt rul",
          "labelTrue": "Nulstil ved opfyldt vedligeholdelse"
        },
        {
          "type": "tagbox",
          "name": "granted_version_ids",
          "title": "Giver automatisk adgang til versioner",
          "description": "Brugere på denne version får også disse uddannelsesvejs-versioner automatisk",
          "dataSource": "org_path_versions",
          "dataSourceKeyField": "display_name",
          "dataSourceValueField": "version_id"
        },
        {
          "type": "dropdown",
          "name": "inherits_maintenance_from_version_id",
          "title": "Arv vedligeholdelse fra version",
          "description": "Vedligeholdelsesmoduler fra den valgte version tælles med på denne version. Det er ikke det samme som automatisk adgang til andre stier. Du kan stadig tilføje egne moduler her.",
          "dataSource": "org_path_versions",
          "dataSourceKeyField": "display_name",
          "dataSourceValueField": "version_id",
          "showClearButton": true
        },
        {
          "type": "dropdown",
          "name": "visibility",
          "title": "Synlighed",
          "defaultValue": "private",
          "isRequired": true,
          "choices": [
            {
              "value": "private",
              "text": "Private"
            },
            {
              "value": "shared",
              "text": "Shared"
            }
          ]
        }
      ]
    },
    {
      "name": "page2",
      "elements": [
        {
          "type": "text",
          "name": "version_end_date",
          "title": "Slut dato",
          "description": "Slut dato for version. Bruges kun i sammenspil med migrerings version (næste spørgsmål)",
          "requiredIf": "{migrated_to_version_id} notempty",
          "inputType": "date"
        },
        {
          "type": "dropdown",
          "name": "migrated_to_version_id",
          "title": "Migrerings version",
          "description": "Vælg hvilken version som denne automatisk migreres / fortsætter på. Brugerne forbliver på denne version for historik",
          "requiredIf": "{version_end_date} notempty",
          "choices": [
            "Item 1",
            "Item 2",
            "Item 3"
          ]
        }
      ]
    }
  ],
  "showEmptyFormSubmit": false
}
